import * as _2021 from './2021/forms-2021';
import * as _2022 from './2022/forms-2022';
import SearchWatcherForm from './search-watcher-form'; 

function init() {
  _2021.init();
  _2022.init();
  SearchWatcherForm.init();
}

export default { init };
